import { SignedUrl } from '@/shared';

export const buildSrcSet = (urls: SignedUrl[]) =>
  urls.map(({ url, width, }) => `${url} ${width}w`).join(`, `);
